module.exports = __webpack_public_path__ + "static/media/Cross.82a75352.svg";